<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    width="1200px"
    custom-class="peopleDialog">
    <div class="title" slot="title">
      {{id ? '编辑人员' : '添加人员'}}
    </div>
      <div class="form-content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="ruleFormYan">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="从业人员姓名" ref="name" prop="name">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.name" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="人员类型" ref="leixing" prop="leixing">
                <div class="flex justify-start align-center">
                  <el-select v-model="ruleForm.leixing" multiple collapse-tags placeholder="请选择" class="inp">
                    <el-option
                      v-for="item in cpeopleTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <div class="tips width">
                    <i class="iconfont icon-xinxitishi"></i>注：如一人多岗的可多选，无法归类的人员选择其主要侧重工作内容，如保洁人员可以选择行政
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="证件类型" ref="card_type" prop="card_type">
                <div class="flex justify-start align-center">
                  <el-select v-model="ruleForm.card_type" placeholder="请选择" class="inp">
                    <el-option
                      v-for="item in cardTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <div class="tips width">
                    <i class="iconfont icon-xinxitishi"></i>注：如一人多岗的可多选，无法归类的人员选择其主要侧重工作内容，如保洁人员可以选择行政
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="证件号码" ref="idcard" prop="idcard">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.idcard" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" ref="phone" prop="phone">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.phone" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div class="flex justify-start align-center">
                <div class="flex-sub flex-sub-w0">
                  <el-form-item label="是否具有无犯罪证明" ref="have_zhengming" prop="have_zhengming">
                    <div class="flex justify-start align-center">
                      <el-select v-model="ruleForm.have_zhengming" placeholder="请选择" class="inp">
                        <el-option
                          v-for="item in isYes"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                      <div class="tips zhengm" v-if="ruleForm.have_zhengming == 1">
                        <i class="iconfont icon-xinxitishi"></i>注：公安机关开具的无犯罪证明，需上传扫描件或图片
                      </div>
                    </div>
                  </el-form-item>
                </div>
                <el-form-item label="" class="errorTips" v-if="ruleForm.have_zhengming == 1" ref="zhengming"
                              prop="zhengming">
                  <div class="flex justify-start align-center">
                    <a :href="ruleForm.zhengming"
                       v-if="ruleForm.zhengming"
                       target="_blank" class="look">查看附件</a>
                    <upload-file
                      class="upZuj"
                      name="zhengming"
                      @uploadFile="uploadFile"
                    >
                      <div class="btnUp" slot="upload">
                        <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传附件
                      </div>
                    </upload-file>
                  </div>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <el-form-item label="聘用方式" ref="pin_type" prop="pin_type">
                <div class="flex justify-start align-center">
                  <el-select v-model="ruleForm.pin_type" placeholder="请选择" class="inp">
                    <el-option
                      v-for="item in pinyongTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <div class="tips width">
                    <i class="iconfont icon-xinxitishi"></i>注：其他包括临时聘用人员、外包人员等
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="flex justify-start align-center">
                <div class="flex-sub flex-sub-w0">
                  <el-form-item label="是否签订合同" ref="have_hetong" prop="have_hetong">
                    <div class="flex justify-start align-center">
                      <el-select v-model="ruleForm.have_hetong" placeholder="请选择" class="inp">
                        <el-option
                          v-for="item in isYes"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                      <div class="tips">
                        <i class="iconfont icon-xinxitishi"></i>注：签订的专职劳动合同、兼职劳动合同、临时劳务协议等均选是，并且上传扫描件或图片作为附件
                      </div>
                    </div>
                  </el-form-item>
                </div>
                <el-form-item label="" class="errorTips" v-if="ruleForm.have_hetong == 1" ref="hetong"
                              prop="hetong">
                  <div class="flex justify-start align-center">
                    <a :href="ruleForm.hetong"
                       v-if="ruleForm.hetong"
                       target="_blank" class="look">查看附件</a>
                    <upload-file
                      class="upZuj"
                      name="hetong"
                      @uploadFile="uploadFile"
                    >
                      <div class="btnUp" slot="upload">
                        <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传附件
                      </div>
                    </upload-file>
                  </div>
                </el-form-item>
              </div>
            </el-col>
            <template v-if="ruleForm.leixing.indexOf(1) != -1">
              <el-col :span="24" v-for="(item,index) in ruleForm.jiaoshi_zizhi" :key="item.id">
                <div class="flex justify-start align-center">
                  <div class="flex-sub flex-sub-w0">
                    <el-form-item label="教师资质"
                                  :ref="'jiaoshi_zizhi.' + index + '.value'"
                                  :prop="'jiaoshi_zizhi.' + index + '.value'"
                                  :rules="{
                                required: false, message: '请选择', trigger: 'change'
                              }">
                      <div class="flex justify-start align-center">
                        <el-select v-model="item.value" @change="zhengChange" placeholder="请选择" class="inp">
                          <el-option
                            v-for="item in jiaoshiZhengOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                        <!--                      <div class="tips short">-->
                        <!--                        <i class="iconfont icon-xinxitishi"></i>注：无选项中列示的资质证书选无-->
                        <!--                      </div>-->
                      </div>
                    </el-form-item>
                  </div>
                  <el-form-item label="行业认证证书类型" class="errorTips margin-left-xs " v-if="item.value == 1"
                                :ref="'jiaoshi_zizhi.' + index + '.type'"
                                :prop="'jiaoshi_zizhi.' + index + '.type'"
                                :rules="{
                                required: false, message: '请选择', trigger: 'change'
                              }">
                    <el-input v-model="item.type" class="inp"></el-input>
<!--                    <el-select v-model="item.type" placeholder="请选择" class="inp width">-->
<!--                      <el-option-->
<!--                        v-for="item in isYes"-->
<!--                        :key="item.value"-->
<!--                        :label="item.label"-->
<!--                        :value="item.value">-->
<!--                      </el-option>-->
<!--                    </el-select>-->
                  </el-form-item>
                  <el-form-item label="" class="errorTips"
                                v-if="item.value && item.value != 6"
                                :ref="'jiaoshi_zizhi.' + index + '.file'"
                                :prop="'jiaoshi_zizhi.' + index + '.file'"
                                :rules="{
                                required: false, message: '请上传', trigger: 'change'
                              }">
                    <div class="flex justify-start align-center">
                      <a :href="item.file" target="_blank" v-if="item.file" class="look">查看证书</a>
                      <upload-file
                        class="upZuj"
                        name="jiaoshi_zizhi"
                        :index="index"
                        @uploadFile="uploadFile"
                      >
                        <div class="btnUp" slot="upload">
                          <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传证书
                        </div>
                      </upload-file>
                      <img src="@/assets/images/tianjiaicon.png" v-if="index == 0" class="add" @click="addZheng()" alt="">
                      <img src="@/assets/images/jianhaoicon.png" v-else class="add" @click="delZheng(index)" alt="">
                    </div>
                  </el-form-item>
                </div>
              </el-col>
            </template>

            <el-col :span="24">
              <div class="flex justify-start align-center">
                <div class="btn-box">
                  <div class="btn" @click="submitForm('ruleForm',1)">临时保存</div>
                  <div class="btn margin-left-xs" @click="submitForm('ruleForm',0)">提交</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
  </el-dialog>
</template>
<script>
import UploadFile from "@/components/UploadFile";
import {imgUrl} from "@/config";
import {isYes, cpeopleTypeOptions, jiaoshiZhengOptions, pinyongTypeOptions, cardTypeOptions} from "@/utils/const";
import rules from "@/utils/rules";
import {save_employ,get_employ} from "@/api";
export default {
  name: "peopleDialog",
  data() {
    return {
      imgUrl:imgUrl,
      isYes:isYes,
      cpeopleTypeOptions:cpeopleTypeOptions,
      pinyongTypeOptions:pinyongTypeOptions,
      jiaoshiZhengOptions:jiaoshiZhengOptions,
      cardTypeOptions:cardTypeOptions,
      ruleForm:{
        name: '', // 培训人员名称
        leixing: [], // 教师类型
        card_type:'', // 证件类型
        idcard:'', // 证件号码
        phone:'',  // 联系电话
        have_zhengming:'',  // 是否具有无犯罪证明
        zhengming:'',  // 无犯罪证明附件
        pin_type:'',  // 聘用方式
        have_hetong:'',  // 是否签订劳动合同
        hetong:'',  // 劳动合同附件
        jiaoshi_zizhi: [
          {
            value: '',
            file: '',
            type:'',
            id: Date.now()
          }
        ],
      },
      rules:{
        phone: [
          {required: false, message: '请输入', trigger: 'blur'},
          rules.phone
        ],
        idcard: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        hetong: [
          {required: false, message: '请上传', trigger: 'change'}
        ],
        card_type: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        have_hetong: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        pin_type: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        zhengming: [
          {required: false, message: '请上传', trigger: 'change'}
        ],
        have_zhengming: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        leixing: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        name: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
      }
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: ''
    },
  },
  components: {UploadFile},
  created() {

  },
  methods: {
    async init(){
      let _data = await get_employ(this.id);
      if(_data.status == 200){
        this.ruleForm = {
          name: _data.data.name, // 培训人员名称
          leixing: _data.data.leixing ? _data.data.leixing.split(',').map(Number) : [], // 教师类型
          card_type:_data.data.card_type, // 证件类型
          idcard:_data.data.idcard, // 证件号码
            phone:_data.data.phone,  // 联系电话
            have_zhengming:_data.data.have_zhengming,  // 是否具有无犯罪证明
            zhengming:_data.data.zhengming,  // 无犯罪证明附件
            pin_type:_data.data.pin_type,  // 聘用方式
            have_hetong:_data.data.have_hetong,  // 是否签订劳动合同
            hetong:_data.data.hetong,  // 劳动合同附件
            jiaoshi_zizhi: _data.data.jiaoshi_zizhi ? _data.data.jiaoshi_zizhi : [
            {
              value: '',
              file: '',
              type:'',
              id: Date.now()
            }
          ]
        }
      }
    },
    submitForm(formName,is_zancun) {
      if(is_zancun == 1){
        this.submitInfo(is_zancun)
      }else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitInfo(is_zancun)
          }
        });
      }

    },
    async submitInfo(is_zancun){
      let _data = await save_employ(
        is_zancun,
        this.id,
        this.ruleForm.name,
        this.ruleForm.leixing.join(','),
        this.ruleForm.card_type,
        this.ruleForm.idcard,
        this.ruleForm.phone,
        this.ruleForm.have_zhengming,
        this.ruleForm.zhengming,
        this.ruleForm.pin_type,
        this.ruleForm.have_hetong,
        this.ruleForm.hetong,
        JSON.stringify(this.ruleForm.jiaoshi_zizhi)
      )
      if(_data.status == 200) {
        this.$message.success(_data.msg);
        this.handleClose()
      } else {
        this.$message.error(_data.msg);
      }
    },

    handleClose(data = false){
      this.$refs.ruleForm.resetFields()
      this.$emit('handleClose',data)
    },

    uploadFile(data) {
      if(data.index === '') {
        this.ruleForm[data.name] = data.file.url
      }else {
        this.ruleForm[data.name][data.index].file = data.file.url
      }
    },
    zhengChange(e){
      if(e == 6) {
        this.ruleForm.jiaoshi_zizhi = [{
          value: 6,
          file: '',
          type:'',
          id: Date.now()
        }];
      }
    },
    addZheng() {
      this.ruleForm.jiaoshi_zizhi.push({
        value: '',
        file: '',
        type: '',
        id: Date.now()
      });
    },
    delZheng(index) {
      this.ruleForm.jiaoshi_zizhi.splice(index, 1);
    },
  },
  watch: {
    dialogVisible(){
      if(this.dialogVisible) {
       if(this.id) {
         this.init()
       }
      }
    }
  },
  filters: {}
}
</script>

<style scoped lang="scss">
.peopleDialog {
  .title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }
  .form-content {
    width: 100%;

    .width {
      width: 400px;
    }

    .btn-box {
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 30px 0;

      .btn {
        width: 180px;
        height: 40px;
        background-image: linear-gradient(0deg,
          #2791ff 0%,
          #81b6ff 100%);
        border-radius: 20px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        letter-spacing: 1px;
        color: #ffffff;
        cursor: pointer;
      }
    }

    .add {
      width: 36px;
      margin-left: 10px;
      margin-top: 15px;
      cursor: pointer;
    }

    .inp {
      flex: 1;
    }

    .tips {
      width: max-content;
      padding: 0 10px;
      height: 36px;
      background-color: #fef0ef;
      border-radius: 4px;
      margin-left: 10px;
      font-size: 14px;
      color: #f34336;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      line-height: 16px;

      i {
        font-size: 20px;
        color: #f34336;
        margin-right: 4px;
      }
      &.short {
        width: 120px;
      }
      &.zhengm {
        width: 250px;
      }
      &.width {
        width: 350px;
      }
    }

    .look {
      width: max-content;
      padding: 0 10px;
      height: 36px;
      border: 1px solid #2791ff;
      color: #2791ff;
      line-height: 34px;
      text-align: center;
      font-size: 14px;
      margin-left: 10px;
      border-radius: 4px;
      margin-top: 15px;
    }

    .btnUp {
      width: max-content;
      padding: 0 10px;
      height: 36px;
      margin-left: 10px;
      background-image: linear-gradient(90deg,
        #2791ff 0%,
        #81b6ff 100%);
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #ffffff;

      i {
        font-size: 20px;
        color: #ffffff;
        margin-right: 5px;
        font-weight: 100;
      }
    }
  }
}
</style>


